import React from 'react';
import { pure, compose, withProps, lifecycle } from 'recompose';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { uniqueId } from '../../../utils';

const VideoPlayer = ({ playerId }) => (
  <video
    id={playerId}
    className="video-js vjs-default-skin"
    controls="true"
    preload="true"
    data-setup={`{
      "playbackRates": [1, 2, 4, 6, 8, 10],
      "controlBar": {
        "volumePanel": false,
        "fullscreenToggle": true
      }
    }`}
  />
);

export default pure(compose(
  withProps(() => ({
    playerId: uniqueId(),
  })),
  lifecycle({
    componentWillReceiveProps({ url, state, position, playbackRate }) {
      if (!this.player) {
        return;
      }
      if (this.props.url !== url) {
        this.suppressUpdateTime = true;
        if (url.length !== 0) {
          this.player.src(url);
          this.player.load();
          this.player.playbackRate(this.props.playbackRate);
        } else {
          this.player.reset();
        }
      }
      if (position !== undefined && position !== this.props.position) {
        try {
          this.player.currentTime(position * this.player.duration());
        } catch (e) {
          //
        }
      }
      if (playbackRate !== undefined && playbackRate !== this.props.playbackRate) {
        this.player.playbackRate(playbackRate);
      }
      if (state !== this.props.state) {
        switch (state) {
          case 'playing':
            this.player.play();
            break;
          case 'pause':
            // this.player.pause();
            break;
          default:
        }
      }
    },
    componentDidMount() {
      this.player = videojs(this.props.playerId);
      this.player.on('loadedmetadata', () => {
        if (this.props.onLoadedMetadata) {
          this.props.onLoadedMetadata(this.player);
        }
        if (this.props.position) {
          this.player.currentTime(this.props.position * this.player.duration());
        }
        if (this.props.state === 'playing') {
          this.player.playbackRate(this.props.playbackRate);
          this.player.play();
        }
        this.suppressUpdateTime = false;
      });
      this.player.on('timeupdate', () => {
        if (this.props.onTimeUpdate && !this.suppressUpdateTime) {
          this.props.onTimeUpdate(this.player);
        }
      });
      this.player.on('ended', () => {
        if (this.props.onEnded) {
          this.props.onEnded(this.player);
        }
      });
      this.player.on('playing', () => {
        if (this.props.onPlaying) {
          this.props.onPlaying(this.player);
        }
      });
      this.player.on('pause', () => {
        if (this.props.onPause) {
          this.props.onPause(this.player);
        }
      });
      if (this.props.url) {
        this.player.src(this.props.url);
        this.player.playbackRate(this.props.playbackRate);
      }
    },
  }),
)(pure(VideoPlayer)));



// WEBPACK FOOTER //
// ./src/components/tools/VideoTool/VideoPlayer.jsx